<template>
  <div
    v-if="this.beneficiary === null"
    id="modal_popup_loading-beneficiary"
    class="modal-popup"
  >
    <div class="modal-popup-content">
      <img src="@/assets/images/loading.gif" />
      <!-- <p v-html="$t('loadingPopupMessage')">{{ $t('loadingPopupMessage') }}</p> -->
    </div>
  </div>
  <div v-else>
    <div class="beneficary-details-page">
      <div class="left">
        <h1>
          {{ this.beneficiary.security_code }} -
          {{ this.beneficiary.first_name + " " + this.beneficiary.last_name }}
        </h1>
        <!-- <p>{{ this.beneficiary.security_code }}</p> -->
      </div>
      <div class="right">
        <!-- 
        <a
          class="notification-action custom-notification-action"
          @click="
						showModalPopup(
							'modal_popup_actionRequest',
							true,
							null,
							'TRANSFER'
              )
              "
              >{{ $t("suspendUserLabel") }}</a>
              <a
              class="notification-action disabled custom-notification-action"
              @click="
              showModalPopup('modal_popup_actionRequest', true, null, 'TRANSFER')
              "
              >{{ $t("transferUserLabel") }}</a>
              -->
              <a v-if="this.userRole === 'FAC'"
        class="notification-action disabled custom-notification-action"
        @click="
          showModalPopup(
            'modal_popup_actionRequest',
            true,
            null,
            'DELETE',
            true
          )
          "
        >{{ $t("deleteUserLabel") }}</a
      >
      </div>
      <!-- 
      <div v-if="!this.beneficiary.active" class="notification desktop">
        <table cellpadding="10" cellspacing="0" width="95%" align="center">
          <tr>
            <td width="7%" valign="top">
              <img src="@/assets/images/alerte.svg" />
            </td>
            <td width="75%" valign="top">
              <h2>{{ $t("suspendedBeneficiaryTitle") }}</h2>
              <p class="gri">{{ $t("suspendedBeneficiaryMessage") }}</p>
            </td>
            <td width="18%">
              <a
                class="notification-action"
                @click="
									showModalPopup(
										'modal_popup_actionRequest',
										true,
										null,
										'ACTIVATE'
									)
								"
              >{{ $t("reactivateBeneficiaryButtonLabel") }}</a>
            </td>
          </tr>
        </table>
        
      </div>
      -->
      <br />
      <div :class="!this.beneficiary.active && 'class'">
        <!--  <div class="container-alb">
          <table width="90%" align="center" cellpadding="20" cellspacing="0">
            <tr>
              <td align="left">
                <small>{{ $t("surnameFieldLabel") }}</small>
                <br />
                <input
                  type="text"
                  id="beneficiaryFirstName"
                  v-model="beneficiary.first_name"
                  class="formedituser"
                  disabled
                />
              </td>
              <td align="left">
                <small>{{ $t("lastNameField") }}</small>
                <br />
                <input
                  id="beneficiaryLastName"
                  type="text"
                  v-model="beneficiary.last_name"
                  class="formedituser"
                  disabled
                />
              </td>
            </tr>

            <tr>
              <td align="left" colspan="2">
                <small>{{ $t("cnpFieldLabel") }}</small>
                <br />
                <input type="text" :value="beneficiary.security_code" class="formedituser" disabled />
              </td>
            </tr>
          </table>

           <table cellpadding="20" cellspacing="0" width="90%" align="center">
            <tr v-if="!this.editMode">
              <td>
                <a
                  class="notification-action custom-notification-action"
                  @click="editBeneficiaryDetails()"
                >{{ $t("editButtonLabel") }}</a>
              </td>
            </tr>
            <tr v-if="this.editMode">
              <td>
                <a
                  class="notification-action"
                  @click="submitBeneficiaryDetails()"
                >{{ $t("saveChangesLabel") }}</a>
              </td>
              <td>
                <a 
                  class="resetButton"
                  @click="resetBeneficiaryDetails()"
                >
                  {{
                  $t("cancelChangesLabel")
                  }}
                </a>
              </td>
            </tr>
          </table>

          <br clear="all" />
        </div>-->
        <div
          v-for="(entry, index) in this.beneficiary.accounts"
          :key="index"
          class="box-left margin-bottom-10"
          :class="index % 2 === 1 && 'clear-none'"
        >
          <div class="container-alb">
            <div class="usage-volume-container">
              <span>
                <img
                  :src="
                    require('@/assets/images/product_' + entry.product + '.svg')
                  "
                />
                &nbsp;&nbsp;{{ getProductNameMethod(entry.product) }}
              </span>
              <br />

              <br />
              <div v-if="entry.card && entry.card !== null">
                <p v-if="!entry.card.virtual">{{ $t("deliveryPointLabel") }}</p>

                <select
                  class="filtrare"
                  v-model="entry.card.addressCode"
                  v-if="!entry.card.virtual"
                >
                  >
                  <option
                    v-for="(delivery, index) in deliveryAddresses"
                    :key="index"
                    :value="delivery.codcom"
                    :selected="delivery.codcom === entry.card.addressCode"
                  >
                    {{ !delivery.address ? delivery.codcom : delivery.codcom + " - " + delivery.address.street_name +
                      ", " +
                      delivery.address.locality}}
                  </option>
                </select>
                <br />
                <div class="grey-card">
                  <p align="center">
                    {{ $t("cardNumberLabel") }}
                    {{ entry.card && entry.card.pan }}
                    <br />

                    {{ $t("beneficiariesTableType") + ": " }}
                    {{ $t("beneficiariesTableDigital_" + entry.card.virtual) }}
                    <br />

                    {{ $t("beneficiariesTableCardStatus") + ": " }}
                    {{ $t("cardStatus_" + entry.card.state) }}
                    <br />
                    {{
                      entry.card &&
                      $t("cardExpiryLabel") + " " + entry.card.expire
                    }}
                    <br />
                  </p>
                  <br />
                  <div class="text-center">
                    <a
                      v-if="
                        entry.card.state === 'B' ||
                        entry.card.state === 'F' ||
                        entry.card.state === 'D'
                      "
                      class="notification-outline"
                      @click="
                        showModalPopup(
                          'modal_popup_actionRequest',
                          true,
                          entry,
                          'REPL'
                        )
                      "
                      >{{ $t("reissueCardButtonLabel") }}</a
                    >
                    <!--  <a
                      v-if="
												entry.card.state === 'A' || entry.card.state === 'C'
											"
                      class="notification-outline"
                      @click="
												showModalPopup(
													'modal_popup_actionRequest',
													true,
													entry,
													'PIN'
												)
											"
                    >{{ $t("reissuePINButtonLabel") }}</a>
                    <a
                      v-if="entry.card.state === 'RP'"
                      class="notification-outline"
                      @click="
												showModalPopup(
													'modal_popup_actionRequest',
													true,
													entry,
													'VALIDATE_PIN'
												)
											"
                    >{{ $t("validateReissuePINButtonLabel") }}</a>
                    <a
                      v-if="entry.card.state === 'RC'"
                      class="notification-outline"
                      @click="
												showModalPopup(
													'modal_popup_actionRequest',
													true,
													entry,
													'VALIDATE_REPL'
												)
											"
                    >{{ $t("validateReissueCardButtonLabel") }}</a>
                    -->
                  </div>
                  <!-- <a href="#" class="notification-outline">{{$t('')}}</a> -->

                  <!-- <div class="notificare">
                    <div>{{ $t("notificationsChooseLabel") }}</div>
                    <div>
                      <div class="custom-control custom-switch">
                        <input
                          type="checkbox"
                          :id="'customSwitch' + entry.id"
                          class="custom-control-input"
                          :checked="entry.sms === ''"
                          @change="smsChecked($event.target, entry)"
                        />
                        <label class="custom-control-label" :for="'customSwitch' + entry.id"></label>
                      </div>
                    </div>
                  </div>-->
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="container-alb moverflow">
          <table cellpadding="10" cellspacing="0" width="95%" align="center">
            <tr>
              <td>
                <h3 class="table-title">{{ $t("beneficiaryOrderHistory") }}</h3>
              </td>
              <!-- <td align="right">
                <input
                  type="text"
                  v-model="search"
                  placeholder="search"
                  class="formedituser search-input"
                />
                <a class="search-btn cursor-pointer">
                  <img src="@/assets/images/search.svg" alt />
                </a>
              </td>-->
            </tr>
          </table>

          <table
            v-if="this.historyDetails !== null"
            cellpadding="10"
            cellspacing="0"
            width="95%"
            class="hover-table"
            align="center"
          >
            <tr>
              <td valign="middle">
                <strong>{{ $t("noCrtLabel") }}</strong>
              </td>
              <td @click="() => (sortBy = 'date')" valign="middle">
                <strong>{{ $t("ordersTableHeaderDate") }}</strong
                >&nbsp;
                <img
                  src="@/assets/images/arrow-down-fill.svg"
                  @click="sortBy === 'date' && changeReverse()"
                  :style="
                    sortBy === 'date' && reverse && 'transform: rotate(180deg)'
                  "
                />
              </td>
              <td @click="() => (sortBy = 'product')" valign="middle">
                <strong>{{ $t("ordersTableHeaderProduct") }}</strong
                >&nbsp;
                <img
                  src="@/assets/images/arrow-down-fill.svg"
                  @click="sortBy === 'product' && changeReverse()"
                  :style="
                    sortBy === 'product' &&
                    reverse &&
                    'transform: rotate(180deg)'
                  "
                />
              </td>
              <td
                @click="() => (sortBy = 'order_type')"
                class="priority-3"
                valign="middle"
              >
                <strong>{{ $t("ordersTableHeaderType") }}</strong
                >&nbsp;
                <img
                  src="@/assets/images/arrow-down-fill.svg"
                  @click="sortBy === 'order_type' && changeReverse()"
                  :style="
                    sortBy === 'order_type' &&
                    reverse &&
                    'transform: rotate(180deg)'
                  "
                />
              </td>
              <td class="priority-4" valign="middle">
                <strong>{{ $t("ordersTableHeaderAmount") }}</strong
                >&nbsp;
              </td>
              <td class="priority-5" valign="middle">
                <strong>{{ $t("orderTableHeaderLabel") }}</strong
                >&nbsp;
              </td>
            </tr>
            <template v-for="(entry, index) in this.filterHistory">
              <tr
                :key="index"
                class="trhover parent"
                :class="index % 2 === 0 && 'gri-cell'"
              >
                <td valign="middle">
                  <a
                    class="
                      detailsOrderMobile
                      priority-show-5
                      display-inline-block
                    "
                    @click="selectHistoryDetailsMobile(index)"
                  >
                    <font-awesome-icon
                      icon="minus-circle"
                      v-if="detailsMobile && entry === selectedHistoryDetails"
                    />
                    <font-awesome-icon icon="plus-circle" v-else />&nbsp;&nbsp;
                  </a>
                  <span class="crt">&nbsp;&nbsp;{{ index + 1 }}</span>
                </td>
                <td valign="middle">{{ displayDate(entry.date) }}</td>
                <td valign="middle">
                  <img
                    :src="
                      require('@/assets/images/bullet_' +
                        entry.product +
                        '.svg')
                    "
                  />
                  &nbsp;&nbsp;{{ getProductNameMethod(entry.product) }}
                </td>
                <td valign="middle" class="priority-3">
                  {{ $t("orderType_" + entry.order_type) }}
                </td>
                <td valign="middle" class="priority-4">
                  {{ entry.description | toCurrency }}
                </td>
                <td valign="middle" class="priority-5">
                  <a
                    class="see-more color-white"
                    :href="'/customer/orders?order_id=' + entry.order_id"
                    >{{ entry.order_id }}</a
                  >
                </td>
              </tr>
              <tr
                :key="index + filterHistory.length"
                class="child"
                :class="index % 2 === 0 && 'gri-cell'"
                v-show="detailsMobile && entry === selectedHistoryDetails"
              >
                <td colspan="12">
                  <p class="priority-show-3">
                    <strong
                      >{{ $t("ordersTableHeaderType") }} : &nbsp;&nbsp;</strong
                    >
                    <span>{{ $t("orderType_" + entry.order_type) }}</span>
                  </p>
                  <p class="priority-show-4">
                    <strong
                      >{{ $t("ordersTableHeaderAmount") }} :
                      &nbsp;&nbsp;</strong
                    >
                    <span>{{ entry.description }}</span>
                  </p>
                  <p class="priority-show-5">
                    <strong
                      >{{ $t("orderTableHeaderLabel") }} &nbsp;&nbsp;</strong
                    >
                    <span>{{ entry.order_id }}</span>
                  </p>
                </td>
              </tr>
            </template>
          </table>
        </div>
      </div>
    </div>
    <div id="modal_popup_actionRequest" class="modal-popup">
      <div
        v-if="this.action && !this.actionError && !this.actionSuccess"
        class="modal-popup-content"
      >
        <a
          @click="showModalPopup('modal_popup_actionRequest', false)"
          class="close-button"
        >
          <img src="@/assets/images/close-button.svg" />
        </a>
        <p
          v-if="this.choosenAccount !== null"
          v-html="
            $t('confirmActionBeneficiary_' + this.action, {
              product: this.getProductNameMethod(this.choosenAccount.product),
            })
          "
        ></p>
        <p
          v-if="this.choosenAccount === null"
          v-html="$t('confirmActionBeneficiary_' + this.action)"
        ></p>
        <div class="buttons">
          <a class="yesButton" @click="confirmAction()">
            {{ $t("notificationsChooseOptionYes") }}
          </a>
          <a
            class="noButton"
            @click="showModalPopup('modal_popup_actionRequest', false)"
            >{{ $t("notificationsChooseOptionNo") }}</a
          >
        </div>
      </div>
      <div
        v-if="this.choosenAccount && this.actionSuccess"
        class="modal-popup-content"
      >
        <a
          @click="showModalPopup('modal_popup_actionRequest', false)"
          class="close-button"
        >
          <img src="@/assets/images/close-button.svg" />
        </a>
        <p
          v-html="
            $t('successActionBeneficiary_' + this.action, {
              product: this.getProductNameMethod(this.choosenAccount.product),
            })
          "
        ></p>
      </div>
      <div v-if="this.actionError" class="modal-popup-content">
        <a
          @click="showModalPopup('modal_popup_actionRequest', false)"
          class="close-button"
        >
          <img src="@/assets/images/close-button.svg" />
        </a>
        <p v-html="$t('errorActionBeneficiary_' + this.actionError.code)">
        </p>
      </div>
    </div>
    <div id="modal_popup_info" class="modal-popup">
      <div class="modal-popup-content">
        <a
          @click="showModalPopup('modal_popup_info', false)"
          class="close-button"
        >
          <img src="@/assets/images/close-button.svg" />
        </a>
        <p
          v-if="this.actionError"
          v-html="$t('errorActionBeneficiary_' + this.actionError.code)"
        ></p>
        <div v-if="this.actionOrderErrors">
          <p
            v-for="(error, index) in this.actionOrderErrors"
            :key="index"
            class="trhover"
            :class="index % 2 === 0 && 'gri-cell'"
          >
            {{ $t(error.error_code, { name: error.from_source_id }) }}
          </p>
        </div>
        <p v-if="this.actionSuccess">{{ this.successMessage }}</p>
      </div>
    </div>
    <!-- <div id="modal_popup_loading" class="modal-popup">
      <div class="modal-popup-content">
        <img src="@/assets/images/loading.gif" />
        <p v-html="$t('loadingPopupMessage')"></p>
      </div>
    </div> -->
  </div>
</template>

<script>
import httpServiceCustomer from "@/http/http-customer.js";
import utils from "@/plugins/utils.js";
import moment from "moment";
import Cookies from "js-cookie";
import $ from "jquery";

export default {
  props: {
    beneficiaryId: Number,
    customer: Object,
    deliveryAddresses: Array,
    msg: String,
    user: Object,
    userRole: String,
  },
  data() {
    return {
      beneficiary: null,
      historyDetails: null,
      choosenAccount: null,
      action: null,
      actionError: null,
      actionOrderErrors: null,
      successMessage: null,
      actionSuccess: false,
      formData: null,
      // editMode: false,
      detailsMobile: false,
      selectedHistoryDetails: null,
      search: "",
      sortBy: "date",
      reverse: true,
    };
  },
  methods: {
    getBeneficiaryDetails() {
      httpServiceCustomer.customerService
        .getBeneficiaryDetails(
          this.customer.company_id,
          this.beneficiaryId,
          this.accessToken
        )
        .then(function (response) {
          // handle success
          return response;
        })
        .catch(function () {
          // handle error
        })
        .then((response) => {
          if (response.status == 200) {
            this.beneficiary = response.data;
            // this.resetBeneficiaryDetails();
          } else if (response.status == 400 || response.status == 403) {
            this.customerBeneficiaries = null;
          }
        });
    },
    getBeneficiaryHistory() {
      httpServiceCustomer.customerService
        .getBeneficiaryHistory(
          this.customer.company_id,
          this.beneficiaryId,
          this.accessToken
        )
        .then(function (response) {
          // handle success
          return response;
        })
        .then((response) => {
          if (response.status == 200) {
            this.historyDetails = response.data;
          } else {
            this.historyDetails = null;
          }
        })
        .catch(() => {
          // handle error
          this.showModalPopup("modal_popup_loading", false, null, this.action);
          this.historyDetails = null;
        });
    },
    getProductNameMethod(productId) {
      return utils.getProductName(productId);
    },
    displayDate(date) {
      return moment(new Date(date), "YYYY-MM-DDThh:mm:ss").format("DD/MM/YYYY");
    },
    smsChecked(element, entry) {
      this.actionSuccess = false;
      if (element.checked) {
        entry.sms = "";
      } else {
        entry.sms = "N";
      }
      this.actionError = null;
      this.actionOrderErrors = null;
      this.actionSuccess = false;

      this.showModalPopup("modal_popup_actionRequest", true, entry, "SMS");
    },
    showModalPopup(elementId, show, entity = null, action = null) {
      this.action = action;
      if (show) {
        this.choosenAccount = entity;
        document.getElementById(elementId).style.visibility = "visible";
      } else {
        document.getElementById(elementId).style.visibility = "hidden";
      }
    },
    // reissueRequest
    confirmAction() {
      this.actionError = null;
      this.actionOrderErrors = null;
      this.actionSuccess = false;

      this.showModalPopup(
        "modal_popup_loading",
        true,
        this.choosenAccount,
        this.action
      );
      if (this.action === "SMS") {
        let account = {
          id: this.choosenAccount.id,
          sms: this.choosenAccount.sms === "" ? "Y" : "N",
        };
        httpServiceCustomer.customerService
          .modifyAccountData(
            this.customer.company_id,
            this.beneficiary.id,
            account,
            this.accessToken
          )
          .then((response) => {
            if (response.status === 200) {
              this.actionSuccess = true;
              this.actionError = null;
              this.successMessage = this.$t("actionSuccessMessage", {
                action: this.$t("cardsAction_" + this.action),
              });
            }
            this.getBeneficiaryDetails();
            this.showModalPopup(
              "modal_popup_loading",
              false,
              null,
              this.action
            );
            this.showModalPopup(
              "modal_popup_actionRequest",
              false,
              null,
              this.action
            );
            this.showModalPopup(
              "modal_popup_info",
              true,
              this.choosenAccount,
              this.action
            );
          })
          .catch((error) => {
            // handle success
            if (error.response.data.code) {
              this.actionError = error.response.data;
              this.actionSuccess = false;
              this.successMessage = this.$t("actionSuccessMessage", {
                action: this.$t("cardsAction_" + this.action),
              });
            } else if (error.response.status === 409) {
              // modal_popup_confirmPinRequest;
              this.actionError = { code: "409" };
            } else {
              this.actionError = { code: "500" };
            }
            this.showModalPopup(
              "modal_popup_loading",
              false,
              null,
              this.action
            );
            this.choosenAccount = null;

            this.showModalPopup(
              "modal_popup_actionRequest",
              false,
              null,
              this.action
            );
            this.showModalPopup(
              "modal_popup_info",
              true,
              this.choosenAccount,
              this.action
            );
          });
      } else if (this.action === "PIN" || this.action === "REPL") {
        let addressOk = false;
        for (let address in this.deliveryAddresses) {
          if (
            this.choosenAccount.card.addressCode ===
            this.deliveryAddresses[address].codcom
          ) {
            addressOk = true;
          }
        }
        this.showModalPopup(
          "modal_popup_actionRequest",
          false,
          null,
          this.action
        );
        if (!addressOk) {
          this.actionError = { code: "NOADDRESS" };
          this.showModalPopup("modal_popup_loading", false, null, this.action);
          this.showModalPopup(
            "modal_popup_info",
            true,
            this.choosenAccount,
            this.action
          );
        } else {
          let cardsActionData = {
            id: 0,
            type: this.action, //"PIN" reemitere PIN
            //"REPL" reemitere CARD
            customer_id: this.customer.company_id,
            product: this.choosenAccount.product,
            details: [
              {
                card_id: this.choosenAccount.card.id,
                address: this.choosenAccount.card.addressCode,
              },
            ],
          };
          httpServiceCustomer.customerService
            .cardsAction(
              cardsActionData,
              this.accessToken,
              this.userRole === "FAC" ? this.user.username : null
            )
            .then((response) => {
              if (response.status === 200) {
                this.actionSuccess = true;
                this.actionError = null;
              }
              this.showModalPopup(
                "modal_popup_loading",
                false,
                null,
                this.action
              );
              this.showModalPopup(
                "modal_popup_info",
                true,
                this.choosenAccount,
                this.action
              );
            })
            .catch((error) => {
              // handle success
              // if (error.response.data.code) {
              //   this.actionError = error.response.data;
              //   this.actionSuccess = false;
              // } else if (error.response.status === 409) {
              //   // modal_popup_confirmPinRequest;
              //   this.actionError = { code: "409" };
              // } else {
              //   this.actionError = { code: "500" };
              // }
              this.getResponseErrors(error.response);
            });
        }
      } else if (this.action === "DELETE") {
        this.showModalPopup("modal_popup_loading", false, null, this.action);
        this.deleteBeneficiary();
      } else if (this.action === "INACTIVATE" || this.action === "ACTIVATE") {
        this.submitBeneficiaryDetails();
      }
    },
    getResponseErrors(response) {
      this.actionError = null;
      this.actionOrderErrors = null;
      this.actionSuccess = false;

      let errorsLink = response.headers["link"].split(";")[0];
      errorsLink = errorsLink.replace(">", "");
      errorsLink = errorsLink.replace("<", "");
      if (errorsLink.includes("exceptions_type")) {
        httpServiceCustomer.customerService
          .getOrderErrors(errorsLink, this.accessToken)
          .then((response) => {
            if (response.status === 200) {
              this.actionOrderErrors = response.data.errors;
              this.actionError = { code: "ERROR" };
            }
          })
          .catch((error) => {
            this.choosenAccount = null;

            // handle success
            if (error.response.data) {
              this.actionSuccess = false;
              this.actionError = { code: error.response.data.code };

              this.viewDetails(false);
            } else if (error.response.status === 409) {
              // modal_popup_confirmPinRequest;
              this.actionError = { code: "409" };
            } else {
              this.actionError = { code: "500" };
            }
          });
      }
      this.showModalPopup("modal_popup_loading", false, null, this.action);

      this.showModalPopup(
        "modal_popup_actionRequest",
        false,
        null,
        this.action
      );
      this.showModalPopup(
        "modal_popup_info",
        true,
        this.choosenAccount,
        this.action
      );
    },
    editBeneficiaryDetails() {
      // this.editMode = true;
      this.action = "MODIFY_DATA";
      $("#beneficiaryFirstName").prop("disabled", false);
      $("#beneficiaryLastName").prop("disabled", false);
      $("#beneficiaryMobilePhone").prop("disabled", false);
    },
    deleteBeneficiary() {
      // this.beneficiaryCardData.notifications = this.notifications;
      this.actionError = null;
      this.actionOrderErrors = null;
      this.actionSuccess = false;
      this.showModalPopup("modal_popup_loading", true, null, this.action);

      httpServiceCustomer.customerService
        .deleteBeneficiary(
          this.customer.company_id,
          this.beneficiary.id,
          this.accessToken
        )
        .then(function (response) {
          // handle success
          return response;
        })
        .catch(function (error) {
          // handle error
          return error.response;
        })
        .then((response) => {
          if (response.status == 200) {
            this.beneficiary = response.data;
            this.actionError = null;
            this.actionSuccess = true;
            this.successMessage = this.$t("deleteDataSucceess");
            this.showModalPopup("modal_popup_actionRequest", false);
            this.showModalPopup("modal_popup_loading", false, null, this.action);

            this.showModalPopup("modal_popup_info", true);
          } else if (response.status == 400) {
            this.actionError = { code: response.data.code };
          } else {
            this.beneficiaryDataError = { code: response.code };
          }
        });
    },
    submitBeneficiaryDetails() {
      // this.beneficiaryCardData.notifications = this.notifications;
      this.actionError = null;
      this.actionOrderErrors = null;
      this.actionSuccess = false;
      let beneficiaryData = this.beneficiary;
      beneficiaryData.mobile_phone = this.formData.mobilePhone;
      httpServiceCustomer.customerService
        .modifyBeneficiaryData(
          this.customer.company_id,
          {
            id: this.beneficiary.id,
            last_name: this.formData.lastName,
            first_name: this.formData.firstName,
            mobile_phone: this.formData.mobilePhone,
            active:
              this.action === "INACTIVATE"
                ? false
                : this.action === "ACTIVATE"
                ? true
                : this.beneficiary.active,
          },
          this.accessToken
        )
        .then(function (response) {
          // handle success
          return response;
        })
        .catch(function (error) {
          // handle error
          return error.response;
        })
        .then((response) => {
          if (response.status == 200) {
            this.beneficiary = response.data;
            this.actionError = null;
            this.actionSuccess = true;
            this.successMessage = this.$t("modifiyDataSucceess");
            // this.editMode = false;
            // this.resetBeneficiaryDetails();
            this.showModalPopup("modal_popup_info", true);
            this.showModalPopup("modal_popup_actionRequest", false);
          } else if (response.status == 400) {
            this.actionError = { code: response.data.code };
          } else {
            this.beneficiaryDataError = { code: response.code };
          }
        });
    },
    // resetBeneficiaryDetails() {
    //   this.formData = {
    //     lastName: this.beneficiary.last_name,
    //     firstName: this.beneficiary.first_name,
    //     mobilePhone: this.beneficiary.mobile_phone
    //   };
    //   this.editMode = false;
    //   $("#beneficiaryFirstName").prop("disabled", true);
    //   $("#beneficiaryLastName").prop("disabled", true);
    //   $("#beneficiaryMobilePhone").prop("disabled", true);
    // },
    selectHistoryDetailsMobile(index) {
      // if(this.reverse){

      // } else {
      //   this.selectedHistoryDetails = this.filterHistory[this.historyDetails.length - index - 1];
      // }
      this.selectedHistoryDetails = this.filterHistory[index];
      this.detailsMobile = !this.detailsMobile;
    },
    changeReverse() {
      this.reverse = !this.reverse;
    },
    selectOrder(orderId) {
      this.$router.push({
        name: "customer_orders",
        params: { order_id: orderId },
      });
    },
  },
  computed: {
    filterHistory: function () {
      var returnHistoryDetails = this.historyDetails;
      const result = returnHistoryDetails
        .filter(
          (x) =>
            x.order_id.toString().indexOf(this.search) > -1 ||
            x.order_type.indexOf(this.search) > -1 ||
            x.product.toString().indexOf(this.search) > -1
        )
        .sort((a, b) =>
          a[this.sortBy] < b[this.sortBy]
            ? -1
            : a[this.sortBy] !== b[this.sortBy]
        );
      return this.reverse ? result.reverse() : result;
    },
    noOfPinRequests() {
      let count = 0;
      for (let index in this.beneficiary.accounts) {
        if (
          this.beneficiary.accounts[index].card &&
          this.beneficiary.accounts[index].card.state === "RP"
        ) {
          count++;
        }
      }
      return count;
    },
    noOfCardRequests() {
      let count = 0;
      for (let index in this.beneficiary.accounts) {
        if (
          this.beneficiary.accounts[index].card &&
          this.beneficiary.accounts[index].card.state === "RC"
        ) {
          count++;
        }
      }
      return count;
    },
  },
  created() {
    this.accessToken = Cookies.get("token");
    this.getBeneficiaryDetails();
    this.getBeneficiaryHistory();
  },
};
</script>
<style scoped src="@/assets/styles/beneficiary.css"></style>
<style scoped>
.left {
  width: auto !important;
}
</style>
